var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 241,
    viewBox: "0 0 240 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_523_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40.1631C20 18.0717 37.9086 0.163086 60 0.163086H220V160.163C220 182.254 202.091 200.163 180 200.163H20V40.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8944 116.651C83.8944 123.902 78.0341 129.763 70.7832 129.763C63.5322 129.763 57.6719 123.902 57.6719 116.651C57.6719 109.4 63.5322 103.54 70.7832 103.54H83.8944V116.651ZM90.4501 116.651C90.4501 109.4 96.3104 103.54 103.561 103.54C110.812 103.54 116.673 109.4 116.673 116.651V149.43C116.673 156.68 110.812 162.541 103.561 162.541C96.3104 162.541 90.4501 156.68 90.4501 149.43V116.651Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.561 64.0077C96.3101 64.0077 90.4498 58.1474 90.4498 50.8964C90.4498 43.6455 96.3101 37.7852 103.561 37.7852C110.812 37.7852 116.672 43.6455 116.672 50.8964V64.0077H103.561ZM103.561 70.6627C110.812 70.6627 116.672 76.523 116.672 83.774C116.672 91.0249 110.812 96.8852 103.561 96.8852H70.6835C63.4326 96.8852 57.5723 91.0249 57.5723 83.774C57.5723 76.523 63.4326 70.6627 70.6835 70.6627H103.561Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.105 83.774C156.105 76.523 161.966 70.6627 169.217 70.6627C176.468 70.6627 182.328 76.523 182.328 83.774C182.328 91.0249 176.468 96.8852 169.217 96.8852H156.105V83.774ZM149.55 83.774C149.55 91.0249 143.689 96.8852 136.438 96.8852C129.187 96.8852 123.327 91.0249 123.327 83.774V50.8964C123.327 43.6455 129.187 37.7852 136.438 37.7852C143.689 37.7852 149.55 43.6455 149.55 50.8964V83.774Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.438 136.318C143.689 136.318 149.55 142.179 149.55 149.43C149.55 156.68 143.689 162.541 136.438 162.541C129.187 162.541 123.327 156.68 123.327 149.43V136.318H136.438ZM136.438 129.763C129.187 129.763 123.327 123.902 123.327 116.651C123.327 109.4 129.187 103.54 136.438 103.54H169.316C176.567 103.54 182.427 109.4 182.427 116.651C182.427 123.902 176.567 129.763 169.316 129.763H136.438Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_523_4465",
    x: 0,
    y: 0.163086,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_523_4465"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_523_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_523_4465"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_523_4465",
    result: "effect2_dropShadow_523_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_523_4465",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.0fdc14ff5caa7619e4f9d5b8ba26a98f.svg";
export { ForwardRef as ReactComponent };